import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import FileLayout from '../../Layouts/FileLayout';

import ProductTitle from '../../Components/Files/ProductTitle';
import VideoPlayer from '../../Components/Files/VideoPlayer';

function App() {
    const [video, setVideo] = useState({});
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { slug, id } = useParams();
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchVideo = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/arquivos/${slug}/videos/${id}`, {
                    method: 'GET',
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/erro/404', {
                            state: {
                                message: { type: '404', text: 'Arquivo não encontrado!' },
                            },
                        });
                        redirected = true;
                        return;
                    } else if (response.status === 403) {
                        navigate('/erro/403', {
                            state: {
                                message: { type: '403', text: 'Você não tem permissão para acessar essa página.' },
                            },
                        });
                        redirected = true;
                        return;
                    }

                    throw new Error('Erro ao buscar o vídeo.');
                }

                const data = await response.json();
                setVideo(data.video);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchVideo();
    }, []);

    useEffect(() => {
        if (!video || !Number.isInteger(video.duracao)) {
            return;
        }

        const updateViews = async () => {
            try {
                const response = await fetch(`${baseUrl}/arquivos/${slug}/visualizar/video/${id}`, {
                    method: 'PUT',
                });

                if (!response.ok) {
                    throw new Error('Erro ao atualizar progresso.');
                }
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            }
        };

        const timeout = setTimeout(() => {
            updateViews();
        }, video.duracao * 800);

        return () => clearTimeout(timeout);
    }, [video.duracao]);

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
            </div>
        );

    return (
        <FileLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <ProductTitle
                            productName={video.nome}
                            loading={loading}
                            breadcrumb={[
                                { label: video.produto_nome, link: `/painel/produtos/${slug}` },
                                { label: 'Vídeos', link: `/painel/produtos/${slug}/videos` },
                            ]}
                        />

                        <div className="flex flex-col items-center -mb-10">
                            <VideoPlayer video={video} slug={slug} id={id} baseUrl={baseUrl} />
                        </div>
                    </div>
                </div>
            </div>
        </FileLayout>
    );
}

export default App;
